import React from "react";

export default ({ data }) => {
  return (
    <div className="images">
      {data.map((item, index) => {
        return (
          <div key={index}>
            <img src={item} alt="Charity" />
          </div>
        );
      })}
    </div>
  );
};
